(function () {
  'use strict';

  function captureFor(target) {
    var src = target.getAttribute('data-first-frame-src');
    if (!src) return;
    var type = target.getAttribute('data-first-frame-type') || '';

    var hidden = document.createElement('video');
    hidden.crossOrigin = 'anonymous';
    hidden.muted = true;
    hidden.playsInline = true;
    hidden.preload = 'auto';
    hidden.style.position = 'fixed';
    hidden.style.left = '-9999px';
    hidden.style.top = '-9999px';
    hidden.style.width = '1px';
    hidden.style.height = '1px';
    hidden.style.opacity = '0';
    hidden.style.pointerEvents = 'none';

    var source = document.createElement('source');
    source.src = src;
    if (type) source.type = type;
    hidden.appendChild(source);

    var cleanup = function () {
      try { hidden.remove(); } catch (e) {}
    };

    var applyPoster = function (dataUrl) {
      if (target.tagName === 'IMG') {
        target.src = dataUrl;
        target.removeAttribute('srcset');
        target.removeAttribute('sizes');
      } else if (target.tagName === 'VIDEO') {
        target.poster = dataUrl;
      } else {
        var img = target.querySelector('img');
        if (img) {
          img.src = dataUrl;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
      }
    };

    var capture = function () {
      try {
        var w = hidden.videoWidth;
        var h = hidden.videoHeight;
        if (!w || !h) { cleanup(); return; }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(hidden, 0, 0, w, h);
        applyPoster(canvas.toDataURL('image/jpeg', 0.85));
      } catch (e) {
        // Tainted canvas (CORS) or other failure — keep existing poster.
      }
      cleanup();
    };

    hidden.addEventListener('seeked', capture, { once: true });
    hidden.addEventListener('loadeddata', function () {
      try {
        hidden.currentTime = 0.05;
      } catch (e) {
        capture();
      }
    }, { once: true });
    hidden.addEventListener('error', cleanup, { once: true });

    document.body.appendChild(hidden);
    hidden.load();
  }

  function applyImageSrc(target, url) {
    if (target.tagName === 'IMG') {
      target.src = url;
      target.removeAttribute('srcset');
      target.removeAttribute('sizes');
      return;
    }
    if (target.tagName === 'VIDEO') {
      target.poster = url;
      return;
    }
    var img = target.querySelector('img');
    if (img) {
      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      return;
    }
    var svg = target.querySelector('svg');
    var fresh = document.createElement('img');
    fresh.src = url;
    fresh.alt = '';
    fresh.loading = 'lazy';
    fresh.style.width = '100%';
    fresh.style.height = '100%';
    fresh.style.objectFit = 'cover';
    if (svg && svg.parentNode) {
      svg.parentNode.replaceChild(fresh, svg);
    } else {
      target.insertBefore(fresh, target.firstChild);
    }
  }

  function fetchVimeoThumbnail(target) {
    var vimeoUrl = target.getAttribute('data-vimeo-url');
    if (!vimeoUrl) return;
    var endpoint = 'https://vimeo.com/api/oembed.json?width=1920&url=' + encodeURIComponent(vimeoUrl);
    fetch(endpoint)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.thumbnail_url) return;
        var hd = data.thumbnail_url.replace(/_\d+(x\d+)?(\.\w+)?(\?|$)/, '_2560$2$3');
        applyImageSrc(target, hd);
      })
      .catch(function () {});
  }

  function init() {
    var first = document.querySelectorAll('[data-first-frame-src]');
    for (var i = 0; i < first.length; i++) captureFor(first[i]);
    var vimeo = document.querySelectorAll('[data-vimeo-url]');
    for (var j = 0; j < vimeo.length; j++) fetchVimeoThumbnail(vimeo[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
